import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#707070" : "#D4AF37")};
  background-color: ${(props) => (props.border ? "transparent" : "#D4AF37")};
  width: 100%;
  padding: 8px 18px;
  font-size: 0.875rem;
  outline: none;
  color: ${(props) => (props.border ? "#707070" : "#fff")};
  line-height: 1.4;
  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#0B093B")};
    border: 1px solid #0B093B;
    color: ${(props) => (props.border ? "#0B093B" : "#fff")};
  }
`;

